(function() {
    'use strict';
    
a3_cabin_reports.controller('CheckInModalCtrl', CheckInModalCtrl);

    /**
    * @memberof CabinReports
    * @ngdoc controller
    * @name CheckInModalCtrl
    * @description 
    * Check in Modal
    * @ngInject
    */
    function CheckInModalCtrl($scope, CheckInFactory, $route, $uibModalInstance) {
        $scope.showContent = 'actions';
        $scope.cancel = cancel;
        $scope.checkInInfo = null; 
        $scope.CheckInAction = CheckInAction;
        $scope.BackToActions = BackToActions;
        $scope.ConfirmCheckIn = ConfirmCheckIn;
        $scope.SendDelayMessage = SendDelayMessage;
        $scope.GetCheckInInfoFromServer = GetCheckInInfoFromServer;
        $scope.responseObj = { success: false, message: '', checkInInfo: null };
        $scope.results = [];

        $scope.selectedDelayMinutes = 10;
        $scope.onMinutesChange = onMinutesChange;
        $scope.numberDown = numberDown;
        $scope.numberUp = numberUp;
        GetCheckInInfoFromServer();
      
     
        function GetCheckInInfoFromServer(){
            $scope.showContent = 'loading';
            var confirmCheckIn = false;
            CheckInFactory.checkIn(confirmCheckIn)
                .then(res => handleRefreshResponse(res))
                .catch(res => handleRefreshResponse(res));
 
        }    
        function handleRefreshResponse(res) {
            $scope.showContent = 'actions';
            $scope.responseObj = res;
        }

        function CheckInAction(){
            $scope.showContent = 'confirm';
        }
        function BackToActions(){
            $scope.showContent = 'actions';
        }

        function ConfirmCheckIn(){
            $scope.showContent = 'loading';
            var confirmCheckIn = true;
            CheckInFactory.checkIn(confirmCheckIn)
                .then(res => handleSubmitResponse(res))
                .catch(res => handleSubmitResponse(res));
 
        }

        function handleSubmitResponse(res) {
            $scope.showContent = 'results';
            $scope.responseObj = res;
        }


        function onMinutesChange(minutes){
            $scope.selectedDelayMinutes = minutes;
        }


        function SendDelayMessage(){
            $scope.showContent = 'loading';
            CheckInFactory.saveCheckInDelay($scope.selectedDelayMinutes)
                .then(res => handleDelayMessageResponse(res))
                .catch(res => handleDelayMessageResponse(res));
        }

        function handleDelayMessageResponse(res) {
            $scope.showContent = 'results';
            $scope.responseObj.success = res.success;
            $scope.responseObj.message = res.message;
        }

        /**
         * Decrease field value by 5
         */
         function numberDown(selectedDelayMinutes){
            if(selectedDelayMinutes > 0){
                $scope.selectedDelayMinutes = selectedDelayMinutes - 5;
            }
        }   

        /**
         * Increase field value by 5
         */
        function numberUp(selectedDelayMinutes){
            $scope.selectedDelayMinutes = selectedDelayMinutes + 5;
        }

        /**
        * Closes modal
        */
        function cancel() {
            $uibModalInstance.close('cancel');

            // if($scope.responseObj.success){
            //     $route.reload();
            // }
        }
    }

})();
